import { Component } from '@angular/core';
import { SupportService } from '../services/support.service';
import { SpinnerService } from 'src/app/shared/services';
import { MatDialog } from '@angular/material/dialog';
import { DialogService } from 'src/app/shared/services/dialog.service';

import { finalize } from 'rxjs';
import {
  MatRow,
  MatCell,
  MatHeaderRow,
  MatHeaderCell,
  MatTableModule,
} from '@angular/material/table';

@Component({
    selector: 'app-energy-credit-support',
    imports: [MatTableModule, MatRow, MatCell, MatHeaderRow, MatHeaderCell],
    templateUrl: './energy-credit-support.component.html',
    styleUrl: './energy-credit-support.component.scss'
})
export class EnergyCreditSupportComponent {
  constructor(
    private supportService: SupportService,
    private spinner: SpinnerService,
    public dialog: MatDialog,
    public dialogService: DialogService,
  ) {}

  displayedColumns: string[] = ['task', 'action'];

  data = [
    {
      task: 'Trigger Energy Credit Submission Export',
      action: () => this.triggerSubmissionExport(),
    },
    {
      task: 'Trigger Heat Pump Invoice Sync',
      action: () => this.triggerHeatPumpInvoiceSync(),
    },
    {
      task: 'Trigger Energy Efficiency Backfill',
      action: () => this.triggerEnergyEfficiencyBackfill(),
    },
  ];

  triggerSubmissionExport() {
    this.supportService
      .getNumberOfExportableSubmissions()
      .subscribe((count) => {
        const formattedCount = new Intl.NumberFormat('en-us').format(count);
        const ref = this.dialogService.openDialog(
          'Confirm Submission Export',
          `This will submit approximately ${formattedCount} submissions for export. Do you want to proceed? This action cannot be undone.`,
          'Cancel',
          'Confirm',
          true,
        );
        ref.afterClosed().subscribe((result) => {
          if (result) {
            this.spinner.show();
            this.supportService
              .triggerEnergyCreditSubmissionExport()
              .pipe(finalize(() => this.spinner.hide()))
              .subscribe();
          }
        });
      });
  }

  triggerHeatPumpInvoiceSync() {
    const ref = this.dialogService.openDialog(
      'Confirm Heat Pump Invoice Sync',
      `This will sync all submissions to OnBase to set their Heat Pump Invoice. Do you want to proceed? This action cannot be undone.`,
      'Cancel',
      'Confirm',
      true,
    );
    ref.afterClosed().subscribe((result) => {
      if (result) {
        this.spinner.show();
        this.supportService
          .triggerHeatPumpInvoiceSync()
          .pipe(finalize(() => this.spinner.hide()))
          .subscribe();
      }
    });
  }

  triggerEnergyEfficiencyBackfill() {
    const ref = this.dialogService.openDialog(
      'Confirm Energy Efficiency Backfill',
      `This will backfill all the energyEfficiencyType submission value for all V3 Submissions. Do you want to proceed? This action cannot be undone.`,
      'Cancel',
      'Confirm',
      true,
    );
    ref.afterClosed().subscribe((result) => {
      if (result) {
        this.spinner.show();
        this.supportService
          .triggerEnergyEfficiencyBackfill()
          .pipe(finalize(() => this.spinner.hide()))
          .subscribe();
      }
    });
  }
}
